import { render, staticRenderFns } from "./OCPrizeCard.html?vue&type=template&id=07c191ce&scoped=true&"
import script from "./OCPrizeCard.ts?vue&type=script&lang=ts&"
export * from "./OCPrizeCard.ts?vue&type=script&lang=ts&"
import style0 from "./OCPrizeCard.css?vue&type=style&index=0&id=07c191ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c191ce",
  null
  
)

export default component.exports